import { render, staticRenderFns } from "./TifReporteLiquidaciones.vue?vue&type=template&id=231c0725"
import script from "./TifReporteLiquidaciones.vue?vue&type=script&lang=js"
export * from "./TifReporteLiquidaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports